// Helpers for the Create Voucher page (/vouchers/new) Scope section.
//
// Regression: GitHub issue #87 — "Applicable Products and Categories dropdowns
// show 'No options' on Create Voucher page". The page previously passed
// options={[]} to both multi-selects. These helpers shape the product /
// category lists returned by the API into {value,label} options consumed by
// the @bbpos/ui Select component.

export interface ScopeOption {
  value: string;
  label: string;
}

interface NamedRecord {
  id: string;
  name: string;
}

export function mapProductsToScopeOptions(
  products: readonly NamedRecord[] | undefined | null,
): ScopeOption[] {
  if (!products) return [];
  return products
    .filter((p) => p && typeof p.id === 'string' && typeof p.name === 'string')
    .map((p) => ({ value: p.id, label: p.name }));
}

// QA 7.5.16 — customer restriction options show the phone so two customers
// with the same name can be told apart.
export function mapCustomersToScopeOptions(
  customers: readonly (NamedRecord & { phone?: string })[] | undefined | null,
): ScopeOption[] {
  if (!customers) return [];
  return customers
    .filter((c) => c && typeof c.id === 'string' && typeof c.name === 'string')
    .map((c) => ({ value: c.id, label: c.phone ? `${c.name} (${c.phone})` : c.name }));
}

export function mapCategoriesToScopeOptions(
  categories: readonly NamedRecord[] | undefined | null,
): ScopeOption[] {
  if (!categories) return [];
  return categories
    .filter((c) => c && typeof c.id === 'string' && typeof c.name === 'string')
    .map((c) => ({ value: c.id, label: c.name }));
}
